import { Table } from 'antd';

import { useFindAgsAccessApprovers } from '../data/ags-approvers';

import { ApproverTableProps } from './approver-table';

export const AgsApproverTable = ({ accessSource, externalId, name, ...props }: ApproverTableProps) => {
  const { data, isFetching, isLoading } = useFindAgsAccessApprovers(accessSource, externalId);

  return (
    <Table
      {...props}
      caption="Approvers"
      columns={[
        { title: 'Wwid', dataIndex: 'enterpriseId' },
        { title: 'Name', dataIndex: 'name' },
        {
          title: 'Email Address',
          dataIndex: 'emailAddress',
          render: (email) => (
            <a
              href={`mailto:${email}?subject=Access Approval Query For the ${accessSource
                .toLowerCase()
                .split('_')
                .map((x) => x.charAt(0).toUpperCase() + x.slice(1))
                .join(' ')} ${name}`}
            >
              {email}
            </a>
          ),
        },
      ]}
      dataSource={data}
      loading={isFetching || isLoading}
      pagination={false}
      rowKey="enterpriseId"
      showHeader={false}
      size="small"
      style={{ marginTop: '1em' }}
    />
  );
};
